import { xml2js } from 'xml-js';

import { server } from '@api/request';

import { isString, isObject } from '@tools/type-guards';

export interface SiteStatusItem {
  title: string;
  description: string;
  guid: string;
  link: string;
  pubDate: string;
}

/**
 * Get a list of current site status items
 *
 * @returns A list of site status items.
 */
export async function getStatus() {
  const items: SiteStatusItem[] = [];

  const res = await server.get('v2/status/feed.rss');

  if (!isString(res)) return items;

  const data = xml2js(res, { compact: true });

  if (!isObject(data)) return items;

  const rss = data.rss;

  if (!isObject(rss)) return items;

  const channel = rss.channel;

  if (!isObject(channel)) return items;

  const list = channel.item;

  if (!Array.isArray(list)) return items;

  for (const item of list) {
    if (!isObject(item)) continue;

    const { title, description, guid, link, pubDate } = item;

    if (
      !isObject(title) ||
      !isString(title._text) ||
      !isObject(description) ||
      !isString(description._text) ||
      !isObject(guid) ||
      !isString(guid._text) ||
      !isObject(link) ||
      !isString(link._text) ||
      !isObject(pubDate) ||
      !isString(pubDate._text)
    ) {
      continue;
    }

    items.push({
      title: title._text,
      description: description._text,
      guid: guid._text,
      link: link._text,
      pubDate: pubDate._text,
    });
  }

  return items;
}

export interface AnnouncementData {
  success: boolean;
  hidden?: boolean;
  digest?: string;
  html?: string;
  link?: string;
}

/**
 * Get the announcement data for the better stack status page.
 *
 * @returns The announcement data.
 */
export async function getAnnouncement() {
  return await server.get<AnnouncementData>('v2/announcements/better-stack');
}
